export default __webpack_public_path__ + "static/custom-software-development-img-81d9213b9d091b22e323b9db331aac92.webp";